import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import { useEffect, useState } from 'react';

const Lead = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }
}, []);

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <Header />
      <main>
      <div className="containerContato">
        <div className='tituloContato'>
          <h1 style={{ marginTop: 10 + 'px', fontSize: 2 + 'em'}}>Agradecemos o contato<br/><span style={{fontSize: 1.2 + 'em'}}>Esperamos que você se junte a nós!</span></h1>
        </div>
      </div>
      </main>
      <Footer />
    </div>
  );
};

export default Lead;